import { setCookie } from './setCookie';

export const setLoggedInInThisSession = () => {
  setCookie('logged-in-in-this-session', '1', {});
};

export const shouldLogoutOnOpen = (hasTimeout: boolean) => {
  return hasTimeout && !document.cookie.includes('logged-in-in-this-session');
};
